import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { showNotification } from "Common/utils/Notification";
import Button from "../ButtonComponent/Button";
import ImageData from "../customImage/ImageSegment";
import Drawer from "../Drawer";
import { X } from "lucide-react";
import ImageView from "../ImageView/ImageView";
import FAQSegmentCard from "../FAQSegmentCard";
import CustomInput from "../InputFields/CustomInput";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import ReactSelect from "../ReactSelect/ReactSelect";

const FaqSegment = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  segmentId,
  versionData,
  segmentType,
  toggleVisiblity,
}) => {
  const faqs = data?.faqs ? data?.faqs : [];
  const [buttons, setButtons] = useState(faqs);
  const [stylCode, setStyleCode] = useState<any>([]);

  const [saticStyle, setStaticStyle] = useState<any>({
    label: data?.style,
    value: data?.style,
  });
  const [styleType, setStyleType] = useState(data?.style);
  const [headerText, setHeaderText] = useState<any>(data?.header_text);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [errors, setErrors] = useState<any>({
    header_text: "",

    faqs: buttons?.map(() => ({ question_text: "", answer_text: "" })),
  });
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  const [backgroundImage, setBackgroundImage] = useState<any>(
    data?.background_image ? data?.background_image : ""
  );
  const [backgroundImageId, setBackgroundImageId] = useState<any>("");
  const [mobileBackground, setMobileBackground] = useState<any>(
    data?.mobile_background_image
  );
  const [mobileBackgroundId, setMobileBackgroundId] = useState<any>(
    data?.mobile_background_image_id
  );
  const [indexBack, setIndexBack] = useState(undefined);

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.media_type === "image") {
        if (indexBack === undefined) {
          setBackgroundImage(imageData.media_url);
          setBackgroundImageId(imageData._id);
          setErrors((prev) => ({ ...prev, ["background_image"]: "" }));
        } else if (indexBack === "background") {
          setMobileBackground(imageData.media_url);
          setMobileBackgroundId(imageData._id);
          setErrors((prev) => ({ ...prev, ["mobile_background_image"]: "" }));
        }
      } else {
        showNotification("Media type should be image", "error");
      }
    }
  }, [imageData, indexBack]);

  const fetchDataByCode = async (code: string) => {
    try {
      const res = await callApi(`v1/content/code/${code}`, "get", {});
      if (res.status === "Success") {
        setStyleCode(res.data.content?.params || []);
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };
  useEffect(() => {
    fetchDataByCode("style");
  }, []);

  const addButton = () => {
    setButtons([...buttons, { question_text: "", answer_text: "" }]);
    setErrors({
      ...errors,
      faqs: [...errors.faqs, { question_text: "", answer_text: "" }],
    });
  };

  const removeButton = (index) => {
    const updatedButtons = buttons.filter((_, i) => i !== index);
    setButtons(updatedButtons);
    const updatedErrors = { ...errors };
    updatedErrors.faqs.splice(index, 1);
    setErrors(updatedErrors);
  };

  const handleStyleData = (keyName, keyValue) => {
    if (keyValue.value === "Select...") {
      setStyleType("");
    } else {
      setStyleType(keyValue.value);
    }
    setStaticStyle(keyValue);
  };

  const handleInputChange = (index, field, value) => {
    const updatedButtons = buttons.map((button, i) =>
      i === index ? { ...button, [field]: value } : button
    );
    setButtons(updatedButtons);
    const updatedErrors = { ...errors };
    if (updatedErrors.faqs[index]) {
      updatedErrors.faqs[index][field] = "";
    }
    setErrors(updatedErrors);
  };

  const handleSave = async (pageId, id) => {
    const newErrors = {
      header_text: headerText.trim() === "" ? "Please enter a header." : "",

      faqs: buttons?.map(() => ({ question_text: "", answer_text: "" })),
    };

    buttons?.forEach((faqs, index) => {
      if (!faqs.question_text?.trim()) {
        newErrors.faqs[index].question_text = "Question text is required.";
      }
      if (!faqs.answer_text?.trim()) {
        newErrors.faqs[index].answer_text = "Answer text is required.";
      }
    });

    setErrors(newErrors);

    if (
      !newErrors.header_text &&
      newErrors?.faqs?.every(
        (error) => !error.question_text && !error.answer_text
      )
    ) {
      const payload = {
        segment_type: "faq_segments",
        header_text: headerText,
        style: styleType,
        faqs: buttons,

        background_image: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImage,
        background_image_id: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImageId,
        mobile_background_image: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackground,
        mobile_background_image_id: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackgroundId,
      };

      try {
        setIsLoading(true);
        const response = await callApi(
          `v1/page/${pageId}/segment/${id}/update-info`,
          "post",
          payload
        );
        setIsLoading(false);
        if (response && response?.status === "Success") {
          setLoader(!loader);
          showNotification("Faqs added successfully!", "success");
        } else {
          showNotification("Something went wrong. Please try again.", "error");
        }
      } catch (e) {
        showNotification(
          "An error occurred while adding the banner. Please try again.",
          "error"
        );
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <ToggleSwitch
          selectValue={data?.is_visible}
          versionValue={versionData?.is_visible}
          toggle={() =>
            toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
          }
          label="Is Segment Visible?"
          required={true}
        />
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Header Text"
            name="headerText"
            type="text"
            placeholder="Enter Header Text"
            value={headerText}
            onChange={(e) => {
              setHeaderText(e.target.value);
              setErrors((prev) => ({ ...prev, header_text: "" }));
            }}
            isVersioned={!!versionData?.header_text}
            versionedValue={versionData?.header_text || ""}
            error={errors.header_text}
          />
        </div>
        <div>
          <div className="flex my-4">
            {backgroundImage ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={backgroundImage}
                  setImageData={setImageData}
                  setImageLink={setBackgroundImage}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack(undefined);
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack(undefined);
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add BackgroundImage
              </button>
            )}
          </div>
          {/* {errors.image_url && (
            <p className="text-sm text-red-500">{errors.image_url}</p>
          )} */}
        </div>
        <div>
          <div className="flex my-4">
            {mobileBackground ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={mobileBackground}
                  setImageData={setImageData}
                  setImageLink={setMobileBackground}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack("background");
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack("background");
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add MobileBackground
              </button>
            )}
          </div>
        </div>

        {stylCode && (
          <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
            <div className="mb-4 xl:col-span-6">
              <label className="inline-block mb-2 text-base font-medium">
                Style
              </label>
              <ReactSelect
                options={stylCode}
                isSearchable={false}
                isMulti={false}
                placeholder={"Please select style type"}
                contentType={saticStyle}
                handleContentChange={handleStyleData}
                name={"style"}
                id={"style-type2"}
                versionData={
                  versionData?.style
                    ? {
                        label: versionData.style,
                        value: versionData.style,
                      }
                    : null
                }
              />
            </div>
          </div>
        )}

        {/* Add Button */}
        <div className="flex justify-end my-4">
          <button
            onClick={addButton}
            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Add Faqs
          </button>
        </div>

        {/* Render Old Data */}
        {versionData?.faqs?.length > 0 && <p>Old Data</p>}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {versionData?.faqs?.length > 0 &&
            versionData?.faqs?.map((button, index) => (
              <div className="py-4 xl:col-span-4">
                <FAQSegmentCard
                  key={index}
                  button={button}
                  handleInputChange={handleInputChange}
                  index={index}
                  errors={errors}
                  segmentId={segmentId}
                  isLoading={isLoading}
                  pageId={pageId}
                  removeButton={removeButton}
                  isEditable={false}
                />
              </div>
            ))}
        </div>

        {/* Render New Data */}
        {buttons?.length > 0 && <p>New Data</p>}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {buttons.map((button, index) => (
            <div className="py-4 xl:col-span-4">
              <FAQSegmentCard
                key={index}
                button={button}
                handleInputChange={handleInputChange}
                index={index}
                errors={errors}
                segmentId={segmentId}
                isLoading={isLoading}
                pageId={pageId}
                removeButton={removeButton}
                isEditable={true}
              />
            </div>
          ))}
        </div>

        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default FaqSegment;
